function downloadFile(fileName: string, fileContent: string, mimetype: string) {
  const blob = new Blob([fileContent], { type: mimetype });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function downloadJsonFile(fileName: string, jsonObject: object) {
  const jsonString = JSON.stringify(jsonObject, null, 2);
  downloadFile(fileName, jsonString, 'application/json');
} 